
import { forwardRef } from "react";
import { CalendarConnection } from "@/types/calendar";
import CalendarConnectionCard from "@/components/CalendarConnectionCard";

interface CalendarConnectionsListProps {
  connections: CalendarConnection[];
  onUpdated: (connection: CalendarConnection) => void;
  onDisconnect: (connection: CalendarConnection) => void;
  autoExpandSettings?: boolean;
  shouldRedirectToHome?: boolean;
}

const CalendarConnectionsList = forwardRef<HTMLDivElement, CalendarConnectionsListProps>(
  ({ connections, onUpdated, onDisconnect, autoExpandSettings = false, shouldRedirectToHome = false }, ref) => {
    if (connections.length === 0) return null;

    return (
      <div ref={ref} className="w-full max-w-2xl space-y-4 mb-6">
        <h3 className="text-lg font-medium text-center mb-4 text-gray-800 dark:text-gray-200">Connected Calendars</h3>
        
        {connections.map((connection) => (
          <CalendarConnectionCard
            key={connection.id}
            calendarConnection={connection}
            onUpdated={onUpdated}
            onDisconnect={onDisconnect}
            autoExpandSettings={autoExpandSettings}
            shouldRedirectToHome={shouldRedirectToHome}
            allConnections={connections}
          />
        ))}
      </div>
    );
  }
);

CalendarConnectionsList.displayName = "CalendarConnectionsList";

export default CalendarConnectionsList;
